(function () {
  var userAgent = navigator.userAgent;
  var isSafari = /Safari/i.test(userAgent) && !/Chrome|Chromium|CriOS|Edg|OPR|Android/i.test(userAgent);

  if (!isSafari) return;

  function restoreImage(image) {
    var source = image.getAttribute('data-src');
    var sourceSet = image.getAttribute('data-srcset');

    if (source) image.setAttribute('src', source);

    if (sourceSet) {
      image.setAttribute('srcset', sourceSet.replace(/,\s*$/, ''));
      image.removeAttribute('data-srcset');
    }

    image.removeAttribute('data-src');
    image.classList.remove('lazyload', 'lazyloading');
    image.classList.add('lazyloaded');
  }

  function restoreImages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('.main-content img.lazyload[data-src]');

    for (var index = 0; index < images.length; index += 1) {
      restoreImage(images[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      restoreImages(document);
    });
  } else {
    restoreImages(document);
  }
})();
